import styled from 'styled-components';

export const MobileHistoryTransactionInfoIconWrapperStyled = styled.div`
    width: 48px;
    height: 48px;
    font-size: 27px;
    margin-bottom: 12px;
`;

export const MobileHistoryTransactionInfoAmountStyled = styled.div`
    font-size: 24px;
    font-weight: 500;
    color: var(--color-white-60);
    
    &.positive {
        color: var(--color-white);
    }
`;

export const MobileHistoryTransactionInfoCopyContainerStyled = styled.div`
    display: flex;
    width: 100%;
    margin-top: 32px;
    
    button.btn-info {
        background: var(--color-neutral-10);
        border-color: var(--color-neutral-10);
        color: var(--color-white-60);
    }
`;

export const MobileHistoryTransactionInfoCompleteStyled = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    
    button.btn-info {
        color: var(--color-white-60);
    }
`;
